"use client";

import {
  Button,
  ButtonProps,
  IconButton,
  IconButtonProps,
} from "@decibeltrade/web-core/components";
import { Url } from "next/dist/shared/lib/router/router";
import Link from "next/link";
import { forwardRef, HTMLAttributeAnchorTarget } from "react";

interface LinkProps {
  href: Url;
  target?: HTMLAttributeAnchorTarget;
  rel?: string;
  replace?: boolean;
  scroll?: boolean;
  prefetch?: boolean;
  shallow?: boolean;
}

export type LinkButtonProps = Omit<ButtonProps, "render"> & LinkProps;

/** A `Button` that renders as a Next.js `Link` component. */
export const LinkButton = forwardRef<HTMLButtonElement, LinkButtonProps>(
  ({ href, target, rel, replace, scroll, prefetch, shallow, ...buttonProps }, ref) => {
    return (
      <Button
        ref={ref}
        {...buttonProps}
        render={(children) => (
          <Link
            href={href}
            target={target}
            rel={rel}
            replace={replace}
            scroll={scroll}
            prefetch={prefetch}
            shallow={shallow}
          >
            {children}
          </Link>
        )}
      />
    );
  },
);
LinkButton.displayName = "LinkButton";

export type LinkIconButtonProps = Omit<IconButtonProps, "render"> & LinkProps;

/** An `IconButton` that renders as a Next.js `Link` component. */
export const LinkIconButton = forwardRef<HTMLButtonElement, LinkIconButtonProps>(
  ({ href, target, rel, replace, scroll, prefetch, shallow, ...buttonProps }, ref) => {
    return (
      <IconButton
        ref={ref}
        {...buttonProps}
        render={(children) => (
          <Link
            href={href}
            target={target}
            rel={rel}
            replace={replace}
            scroll={scroll}
            prefetch={prefetch}
            shallow={shallow}
          >
            {children}
          </Link>
        )}
      />
    );
  },
);
LinkIconButton.displayName = "LinkIconButton";
